import { useCallback } from "react";

import { useGetQuery, useLazyGetQuery } from "slices/api";
import { LOCATIONS, LOCATION_BY_PINCODE } from "tagTypes";

export const useLocationQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/city/location",
    query,
    tags: [LOCATIONS],
  });

export const useLazyLocationQuery = () => {
  const [getLocations, data] = useLazyGetQuery();
  const location = async (query = {}) => {
    return await getLocations(
      {
        endpoint: "/city/location",
        query,
        tags: [LOCATIONS],
      },
      true
    ).unwrap();
  };
  return [location, data];
};

export const useLazyLocationByPincodeQuery = () => {
  const [getLocationsByPincode, data] = useLazyGetQuery();
  const locationByPincode = useCallback(
    async (pincode, query = {}, isFireSafety = false) => {
      return await getLocationsByPincode(
        {
          endpoint: isFireSafety
            ? `/firesafety-address/pincode/${pincode}/city`
            : `/pincode/${pincode}/location`,
          query,
          tags: [LOCATION_BY_PINCODE],
          errorMessage: "Invalid pincode",
        },
        true
      ).unwrap();
    },
    [getLocationsByPincode]
  );
  return [locationByPincode, data];
};
